<template>
	<div class="grid-2-1">
		<div class="dg-card">
			<div class="dg-card-head">
				<h3><span v-text="$t('dashboard_gestao_evolucao_titulo')"></span></h3>
				<span class="dg-hint" :title="$t('dashboard_gestao_evolucao_tooltip')">
					<i class="fas fa-info-circle"></i>
				</span>
			</div>
			<div class="chart-wrap">
				<apexchart
					type="line"
					height="268"
					:options="chartOptions"
					:series="chartSeries"
				></apexchart>
			</div>
		</div>

		<div class="dg-card">
			<div class="dg-card-head">
				<h3><span v-text="$t('dashboard_gestao_funil_titulo')"></span></h3>
				<span class="dg-hint" :title="$t('dashboard_gestao_funil_tooltip')">
					<i class="fas fa-info-circle"></i>
				</span>
			</div>
			<div class="funnel">
				<div v-for="(s, i) in funnel" :key="s.label" class="funnel-row">
					<div class="funnel-label-row">
						<span class="funnel-label">{{ s.label }}</span>
						<span class="funnel-value">
							{{ s.v.toLocaleString('pt-BR') }}
							<span v-if="i > 0" class="funnel-conv"> · {{ s.conv.toFixed(0) }}%</span>
						</span>
					</div>
					<div class="funnel-track">
						<div class="funnel-bar" :style="{ width: s.width + '%', background: s.c }"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import DashboardGestaoController from '@/views/controllers/DashboardGestaoController';

export default {
	name: 'DashboardGestaoRowEvolucao',
	components: { apexchart: VueApexCharts },
	props: {
		cur: { type: Array, default: () => [] },
		funnel: { type: Array, default: () => [] },
	},
	computed: {
		chartSeries() {
			return DashboardGestaoController.getEvolutionChartData(this.cur).series;
		},
		chartOptions() {
			return DashboardGestaoController.getEvolutionChartOptions(this.cur);
		},
	},
};
</script>

<style scoped lang="less">
@card: #ffffff;
@line: #e7e9f0;
@ink: #1a2036;
@muted: #6b7280;

.grid-2-1 {
	display: grid;
	grid-template-columns: 1.7fr 1fr;
	gap: 14px;
	margin-bottom: 14px;
}

@media (max-width: 1100px) {
	.grid-2-1 { grid-template-columns: 1fr; }
}

.dg-card {
	background: @card;
	border-radius: 14px;
	border: 1px solid @line;
	box-shadow: 0 1px 2px rgba(20, 29, 56, 0.04);
}

.dg-card-head {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 16px 18px 4px;

	h3 {
		margin: 0;
		font-size: 14.5px;
		font-weight: 700;
		color: @ink;
		letter-spacing: -0.2px;
	}

	.dg-hint {
		display: inline-flex;
		color: @muted;
		cursor: help;
	}
}

.chart-wrap {
	padding: 6px 10px 14px;
}

.funnel {
	padding: 12px 18px 18px;

	.funnel-row { margin-bottom: 12px; }

	.funnel-label-row {
		display: flex;
		justify-content: space-between;
		font-size: 12px;
		margin-bottom: 4px;
	}

	.funnel-label { color: @ink; font-weight: 600; }
	.funnel-value { color: @muted; font-weight: 700; }
	.funnel-conv { color: @muted; font-weight: 500; }

	.funnel-track {
		height: 22px;
		background: #f0f2f7;
		border-radius: 6px;
		overflow: hidden;
	}

	.funnel-bar {
		height: 100%;
		border-radius: 6px;
		transition: width 0.4s;
	}
}
</style>
